import {
  Directive,
  ElementRef,
  forwardRef,
  HostListener,
  Renderer2,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[telefoneMask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TelefoneMaskDirective),
      multi: true,
    },
  ],
})
export class TelefoneMaskDirective implements ControlValueAccessor {
  private onChange: (value: any) => void;
  private onTouched: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // Quando o Angular escreve no input (ex: tela de edição)
  writeValue(value: any): void {
    const digitos = value?.toString().replace(/\D/g, '') || '';
    const formatado = this.formatarTelefone(digitos);
    this.renderer.setProperty(this.el.nativeElement, 'value', formatado);
  }

  // Angular registra a função de callback para mudanças
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Angular registra a função de callback para "toque" no campo
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Habilita/desabilita o input
  setDisabledState?(isDisabled: boolean): void {
    this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
  }

  // Quando o usuário digita no campo
  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const digitos = value.replace(/\D/g, '');
    const formatado = this.formatarTelefone(digitos);
    this.renderer.setProperty(this.el.nativeElement, 'value', formatado);
    if (this.onChange) this.onChange(digitos); // repassa só os dígitos
  }

  @HostListener('blur')
  onBlur() {
    if (this.onTouched) this.onTouched();
  }

  private formatarTelefone(digitos: string): string {
    if (digitos.length === 0) {
      return '';
    }

    if (digitos.length <= 2) {
      return `(${digitos}`;
    } else if (digitos.length <= 6) {
      return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`;
    } else if (digitos.length <= 10) {
      return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(
        6
      )}`;
    } else {
      return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 3)} ${digitos.slice(
        3,
        7
      )}-${digitos.slice(7, 11)}`;
    }
  }
}
